// import { REFRESH_TOKEN_ENDPOINT } from '@biletiniz/common/AuthApi';
import { useState, useEffect } from '@biletiniz/ui-core';
import { tokenRefreshManager } from '@biletiniz/apollo/token-refresh-manager';

export const useSession = () => {
  const [accessToken, setAccessToken] = useState('');
  const [refreshToken, setRefreshToken] = useState('');
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const setToken = ({
    accessToken: accessTokenProp,
    refreshToken: refreshTokenProp,
  }) => {
    if (accessTokenProp) {
      localStorage.setItem('ACCESS_TOKEN', accessTokenProp);
      setAccessToken(accessTokenProp);
      // Sync with token manager for immediate availability to Apollo
      tokenRefreshManager.setToken(accessTokenProp);
      // axios.defaults.headers.common.Authorization = `Bearer ${accessTokenProp}`;
    }
    if (refreshTokenProp) {
      localStorage.setItem('REFRESH_TOKEN', refreshTokenProp);
      setRefreshToken(refreshTokenProp);
    }
  };

  const clearToken = () => {
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('REFRESH_TOKEN');
    setAccessToken('');
    setRefreshToken('');
    // Clear from token manager as well
    tokenRefreshManager.clearToken();
    // axios.defaults.headers.common.Authorization = undefined;
  };

  // const configureAxiosCallbacks = ({
  //   unauthenticatedCallback,
  //   handleServerError
  // }) => {
  //   axios.interceptors.response.use(
  //     response => {
  //       return response;
  //     },
  //     error => {
  //       const status = error && error.response ? error.response.status : null;
  //       const url = error?.request?.responseURL;
  //       if (status >= 500 && handleServerError && handleServerError.cb) {
  //         return handleServerError.cb();
  //       }
  //       if (
  //         status === 401 &&
  //         unauthenticatedCallback &&
  //         url !== REFRESH_TOKEN_ENDPOINT
  //       ) {
  //         return unauthenticatedCallback(
  //           error,
  //           localStorage.getItem('REFRESH_TOKEN')
  //         );
  //       }
  //       return Promise.reject(error);
  //     }
  //   );
  // };

  useEffect(() => {
    const localAccessToken = localStorage.getItem('ACCESS_TOKEN');
    const localRefreshToken = localStorage.getItem('REFRESH_TOKEN');
    if (!localRefreshToken) {
      setIsSessionExpired(true);
    }
    setAccessToken(localAccessToken);
    setRefreshToken(localRefreshToken);

    // Sync with token manager on initial load
    if (localAccessToken) {
      tokenRefreshManager.setToken(localAccessToken);
    }
  }, []);

  return {
    accessToken,
    refreshToken,
    isSessionExpired,
    setIsSessionExpired,
    setToken,
    clearToken,
    // configureAxiosCallbacks
  };
};
